// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c22653ba","239":"cf230856","732":"95d43b50","762":"83a2104b"}[chunkId] + ".chunk.js";
};